/** Spanish for one part of the app (ADR 0325); see index.ts for the house style. */
export const email: Readonly<Record<string, string>> = {
  // Writing one email (the form; the letter itself stays English)
  Send: "Enviar",
  "Sending…": "Enviando…",
  "Copied!": "¡Copiado!",
  "Copy email": "Copiar email",
  "You can copy the email in the meantime.":
    "Mientras tanto, se puede copiar el email.",
  "Gmail is not connected": "Gmail no está conectado",
  "Connect your Google account under Tools → Integrations and this sends itself. Until then, copy the email and send it from Gmail as before.":
    "Conectar la cuenta de Google en Herramientas → Integraciones y esto se envía solo. Mientras tanto, copiar el email y enviarlo desde Gmail como antes.",
  From: "De",
  Attached: "Adjuntos",
  Template: "Plantilla",
  "Write it myself": "Escribirlo a mano",
  "needs review": "requiere revisión",
  To: "Para",
  "Goes to all {n}. Each of them sees the others.":
    "Va a los {n}. Cada uno ve a los demás.",
  "Add more people by separating the addresses with a comma.":
    "Para agregar más personas, separar las direcciones con coma.",
  Subject: "Asunto",
  Message: "Mensaje",
  "This template has 1 field Roof Board cannot fill: {list}. They will arrive looking exactly like that unless you edit them out.":
    "Esta plantilla tiene 1 campo que Roof Board no puede llenar: {list}. Llegará tal cual a menos que se edite.",
  "This template has {n} fields Roof Board cannot fill: {list}. They will arrive looking exactly like that unless you edit them out.":
    "Esta plantilla tiene {n} campos que Roof Board no puede llenar: {list}. Llegarán tal cual a menos que se editen.",
  "Sends from {from}.": "Se envía desde {from}.",
  "Replies go to {name}, not to you, and it is signed with their Gmail signature.":
    "Las respuestas le llegan a {name}, no a quien lo manda, y lleva la firma de Gmail de esa persona.",
  "Replies come back to you, and your Gmail signature goes on the end.":
    "Las respuestas regresan a esta cuenta y al final va su firma de Gmail.",
  // Why an email is refused (emailRefusal in packages/core)
  "This customer is blacklisted, so the app will not email them. Clear the flag on their contact if that is wrong.":
    "Este cliente está en la lista negra, así que la app no le enviará emails. Si es un error, quitar la marca en su contacto.",
  "This customer is marked no automated contact, so the app will not email them. A person can still call.":
    "Este cliente está marcado como sin contacto automático, así que la app no le enviará emails. Una persona todavía puede llamar.",
  "No email address on this contact. Add one and try again.":
    "Este contacto no tiene email. Agregar uno e intentar de nuevo.",

  // The conversation on a job (ADR 0041)
  You: "Yo",
  "(no subject)": "(sin asunto)",
  "Reply to {name}…": "Responder a {name}…",
  "the customer": "el cliente",
  "Send reply": "Enviar respuesta",
  "This customer has no email address, so there is nobody to reply to.":
    "Este cliente no tiene email, así que no hay a quién responder.",
  Conversation: "Conversación",
  "checking for replies…": "buscando respuestas…",
  "Loading…": "Cargando…",
  "Nothing yet. An email sent from here starts a conversation, and the customer's reply comes back to this screen.":
    "Nada todavía. Un email enviado desde aquí inicia una conversación, y la respuesta del cliente regresa a esta pantalla.",

  // Files on an email
  "Reading…": "Leyendo…",
  "Attach files": "Adjuntar archivos",
  "Remove {name}": "Quitar {name}",
  "That file could not be read. Try choosing it again.":
    "No se pudo leer ese archivo. Intentar elegirlo de nuevo.",
  // attachmentRefusal in packages/core, with its limit of ten files
  "One email can carry 10 files. Take some off, or send the rest in a second email.":
    "Un email puede llevar 10 archivos. Quitar algunos o enviar el resto en un segundo email.",
};
